module.exports = __webpack_public_path__ + "d91ff1d50d70c045d2b3e112d0575292.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/cashier/wx.png
// module id = 643
// module chunks = 0